var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17.5,
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9933 23.3325L19.4551 27.93C18.1393 28.6386 17.4813 28.9928 16.9941 28.7018C16.5069 28.4108 16.5069 27.6636 16.5069 26.1691L16.5069 16.9741C16.5069 15.4796 16.5069 14.7323 16.9941 14.4413C17.4813 14.1503 18.1393 14.5046 19.4551 15.2131L27.9933 19.8106C29.4341 20.5864 30.1544 20.9743 30.1544 21.5716C30.1544 22.1689 29.4341 22.5567 27.9933 23.3325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverPause);
export default __webpack_public_path__ + "static/media/hoverPause.1b0c36a3472c170cb9b9690ad703897b.svg";
export { ForwardRef as ReactComponent };